import {
  Box,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CastShiftRes from "../../../types/res/castShift/CastShiftRes";
import CastNameRes from "types/res/castName/CastNameRes";
type Props = {
  onChangeCheckBox(key: string): any;
  formData: any;
  // visit (来店型) 時にルーム選択 (必須) を表示
  isVisit?: boolean;
  onChangeValue?(key: string): any;
};
const OrderCast: React.FC<Props> = ({
  onChangeCheckBox,
  formData,
  isVisit,
  onChangeValue,
}) => {
  const { t } = useTranslation("order");
  const castShift = useSelector((state) => state.castShift);
  const castNames = useSelector((state) => state.castName);
  const rooms = useSelector((state: any) => state.room);
  const [selectCastShift, setSelectCastShift] = useState<CastShiftRes>();
  const [selectCastName, setSelectCastName] = useState<CastNameRes>();
  useEffect(() => {
    setSelectCastShift(
      castShift?.find((shift) =>
        shift?.cast?.castNames
          ?.map((castName) => castName.castNameId)
          .includes(formData.castNameId)
      )
    );
    setSelectCastName(
      castNames?.find(
        (castName) => castName.castNameId === formData?.castNameId
      )
    );
  }, [formData?.castNameId, castShift]);
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h5" component="h5">
        {t("orderCast.sectionTitle")}
      </Typography>
      <TextField
        label={t("orderCast.castName")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastShift?.cast.displayName || ""}
      />
      <TextField
        label={t("orderCast.tel")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastShift?.cast.tel || ""}
      />
      <TextField
        label={t("orderCast.age")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastName?.age || ""}
      />
      <TextField
        label={t("orderCast.bodyHeight")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastName?.bodyHeight || ""}
      />
      <TextField
        label={t("orderCast.cup")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastName?.cup || ""}
      />
      <TextField
        label={t("orderCast.bust")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastName?.bust || ""}
      />
      <TextField
        label={t("orderCast.waist")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastName?.waist || ""}
      />
      <TextField
        label={t("orderCast.hip")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastName?.hip || ""}
      />
      <TextField
        label={t("orderCast.remarks")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastShift?.cast.remarks || ""}
      />
      <TextField
        label={t("orderCast.castMemo")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastShift?.castMemo || ""}
      />
      <TextField
        label={t("orderCast.staffMemo")}
        size="small"
        variant="outlined"
        style={{ margin: 5 }}
        disabled
        value={selectCastShift?.staffMemo || ""}
      />
      <Box display="flex" alignItems="center">
        <Typography variant="subtitle1" style={{ marginRight: "10px" }}>
          {t("orderCast.ngAreas")}
        </Typography>
        <Typography variant="body2">
          {selectCastShift?.cast.ngAreas?.map((area) => area.name).join(",") ||
            t("orderCast.none")}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <Typography variant="subtitle1" style={{ marginRight: "10px" }}>
          {t("orderCast.ngGuests")}
        </Typography>
        <Typography variant="body2">
          {selectCastShift?.cast.ngGuests
            ?.map((guest) => `${guest.name}(${guest.tel})`)
            .join(",") || t("orderCast.none")}
        </Typography>
      </Box>
    </Box>
  );
};
export default OrderCast;
